import "../tokens.css"
import { urgencyStyle, urgencyLabel, urgencyIsQuiet } from "../tokens"

// Priority/urgency pill. Kept as its own component (rather than overloading
// StatusPill) because the tone/label lookup is urgency-specific — see
// URGENCY_TONE in tokens.js. "Normal"/"Low" render without the dot so the
// common case stays visually quiet; only High/Critical/Urgent call it out.
export const UrgencyBadge = ({ urgency, label }) => {
  const colors = urgencyStyle(urgency)
  const text = label || urgencyLabel(urgency)
  const quiet = urgencyIsQuiet(urgency)
  return (
    <span className="ds-pill" style={{ background: colors.bg, color: colors.fg }}>
      {!quiet && <span className="ds-pill-dot" aria-hidden />}
      {text}
    </span>
  )
}

export default UrgencyBadge
